// extracted by mini-css-extract-plugin
export var map = "style-module--map--2p4iR";
export var itemLabel = "style-module--itemLabel--3aVlZ";
export var img = "style-module--img--1n9aJ";
export var relays = "style-module--relays--2HooE";
export var relay = "style-module--relay--ymcWl";
export var relayAnimation = "style-module--relayAnimation--kgMIB";
export var isProducer = "style-module--isProducer--1f1jL";
export var deploymentInfo = "style-module--deploymentInfo--qKQJC";
export var digitalocean = "style-module--digitalocean--1k2ve";